import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EnumCaptionPipe } from './enum-caption.pipe';
import { EnumSvgPipe } from './enum-svg.pipe';
import { EnumTextPipe } from './enum-text.pipe';
import { PhoneBrPipe } from './phone-br.pipe';
import { FindLeaderPipe } from './find-leader.pipe';
import { AreaPipe } from './area.pipe';
import { ReportFileSizePipe } from './report-file-size.pipe';


@NgModule({
	declarations: [EnumTextPipe, PhoneBrPipe, EnumSvgPipe, EnumCaptionPipe, FindLeaderPipe, AreaPipe, ReportFileSizePipe],
	imports: [
		CommonModule
	],
	exports: [EnumTextPipe, PhoneBrPipe, EnumSvgPipe, EnumCaptionPipe, FindLeaderPipe, AreaPipe, ReportFileSizePipe]
})
export class PipesModule { }
